import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'tmt-ui-kit';

import Link from '~/components/Link/Link';

const LxCard = props => {
  const { data, seeMore } = props;
  if (seeMore) return null;
  return (
    <Link className="link" to={`/local-expert/${data.slug}`}>
      <Card.LxCard
        data={data}
      />
    </Link>
  );
};

LxCard.propTypes = {
  data: PropTypes.object,
  seeMore: PropTypes.string,
};
LxCard.defaultProps = {
  data: {},
};

export default LxCard;
